// src/pages/UnauthorizedPage.js
import React from 'react';
import { useAuth } from '../auth/AuthProvider';
import { AuthFailure, authFailureCopy } from '../auth/authFailure';

export default function UnauthorizedPage() {
  const { signOut, associateId, userEmail, authFailure } = useAuth();

  const failure = authFailure ?? AuthFailure.NOT_AUTHORIZED;
  const { title, body, actionLabel } = authFailureCopy(failure, userEmail);

  // A shared departmental account isn't an error the user made — it's the machine's
  // Windows session passing through. Keep that case visually calmer than a denial.
  const isWrongAccount = failure === AuthFailure.NOT_A_PERSON;

  return (
    <div className="page-center">
      <div style={{ textAlign: 'center', maxWidth: 520 }}>
        <div style={{
          width: 72, height: 72, borderRadius: '50%',
          background: isWrongAccount ? 'var(--gray-100)' : 'var(--red-light)',
          display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          fontSize: '2rem', margin: '0 auto 1.5rem'
        }}>{isWrongAccount ? '👤' : '🔒'}</div>

        <h1 style={{ marginBottom: '.75rem' }}>{title}</h1>
        <p style={{ color: 'var(--gray-600)', marginBottom: '1.5rem', lineHeight: 1.6 }}>
          {body}
        </p>

        {(userEmail || associateId) && (
          <div style={{
            background:   'var(--gray-50)',
            border:       '1px solid var(--gray-200)',
            borderRadius: 'var(--radius)',
            padding:      '1rem 1.25rem',
            marginBottom: '1.5rem',
            textAlign:    'left',
            fontSize:     '.85rem',
            color:        'var(--gray-600)'
          }}>
            <div style={{ fontWeight: 600, marginBottom: '.5rem', color: 'var(--gray-800)' }}>
              Account Details
            </div>

            {userEmail && (
              <div style={{ marginBottom: '.25rem' }}>
                <strong>Signed in as:</strong> {userEmail}
              </div>
            )}

            {associateId && (
              <div style={{ marginBottom: '.25rem' }}>
                <strong>Employee Number:</strong> {associateId}
              </div>
            )}

            {!isWrongAccount && (
              <div style={{
                marginTop:  '.75rem',
                fontSize:   '.78rem',
                color:      'var(--gray-400)',
                borderTop:  '1px solid var(--gray-200)',
                paddingTop: '.75rem'
              }}>
                Please provide the details above to your system administrator
                so they can verify your access configuration.
              </div>
            )}
          </div>
        )}

        {/* signOut ends the Entra session as well as the local one, so the next
            sign-in genuinely starts over rather than looping back here. */}
        <button className="btn btn-primary" onClick={signOut}>
          {actionLabel}
        </button>
      </div>
    </div>
  );
}
